import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import styled, { createGlobalStyle } from 'styled-components';

export const IconButton = styled.button`
  width: 22px;
  height: 14px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 40px;
    height: 40px;
  }
`;

export const LockScroll = createGlobalStyle`
  html, body {
    overflow-y: ${props => (props.locked ? 'hidden' : 'auto')};
  }
`;

export const NavbarSection = styled.div`
  position: absolute;
  width: 100vw;
  height: calc(100vh - 85px);
  display: ${props => (props.open ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  top: 85px;
  left: 0;

  ${media.md`
    height: calc(100vh - 88px);
    top: 88px;
  `}
`;

export const NavbarList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const NavbarLink = styled.a`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 40px;
  font-weight: 500;
  line-height: 85%;
  letter-spacing: -0.8px;
  text-transform: uppercase;
`;

export const LoginButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff9500;
  border-radius: 116.162px;
  padding: 14px 28px;
  gap: 9.293px;
  width: calc(90% - 56px);
  height: 20px;
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 110%;
  text-align: center;
  margin: 0px 0px 60px;
  cursor: pointer;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  ${media.md`
    width: 200px;
  `}
`;

export const BitcoinLogo = styled.img`
  width: 35px;
  height: 35px;
`;

export const SubNavbarLink = styled.a`
  color: #555555;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 85%;
  letter-spacing: -0.4px;
  text-transform: uppercase;
`;
